import { render, staticRenderFns } from "./InvitePatient.vue?vue&type=template&id=76e49f37&scoped=true"
import script from "./InvitePatient.vue?vue&type=script&lang=js"
export * from "./InvitePatient.vue?vue&type=script&lang=js"
import style0 from "./InvitePatient.vue?vue&type=style&index=0&id=76e49f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e49f37",
  null
  
)

export default component.exports